import Modal from '@components/Modal';
import { query } from '@design/templateFns';
import { Fragment, useRef } from 'react';
import styled from 'styled-components';
import * as MapBlock from './BlockMapList';
import { MapProps } from './BlockProps';

export const MapComponents = ({ blocks }: { blocks: any[] }) => {
  if (!blocks?.length) return null;
  const components = blocks.map((block, idx) => {
    let props = MapProps(block);
    /* ----- CUSTOM EXTEND EXAMPLE BELOW -----
      1. Comments below is how to extend it for custom blocks, most of the time you will not need to extend it at all 
      2. You can also temporarily extend to have your own component test data here if you want, just remember to remove it when pushing to master
    */
    if (props == null)
      return (
        <Unknown key={`unknown-${idx}`}>
          <span>
            <b>UNKNOWN BLOCK TYPE</b>
          </span>
          <code>{block == null ? 'block == null, check CMS data' : JSON.stringify(block.sys)}</code>
        </Unknown>
      );

    if (MapBlock[props.contentTypeId]) {
      return <Fragment key={props.id}>{MapBlock[props.contentTypeId](block)}</Fragment>;
    }

    return (
      <Unknown key={props.id || `unknown-${idx}`}>
        <span>
          <b>UNKNOWN BLOCK TYPE:</b>
          {` "${props.contentTypeId}", please add this block type to "web/components/BlockMapper/BlockMapList.ts"`}
        </span>
        <code>{`export { default as ${props.contentTypeId} } from '@components/${props.contentTypeId}/_map';`}</code>
        {/* <Column>
        <Button
          arrow={false}
          variant={'button'}
          url="#"
          label="Add Block Import"
        />
        <Button
          arrow={false}
          variant={'secondary'}
          url="#"
          label="Create Contentful Schema"
        />
      </Column> */}
      </Unknown>
    );
  });
  return <>{components}</>;
};

export const MapAllComponents = () => {
  let modal = useRef<any | null>(null);
  const handleClick = () => {
    modal.current?.toggle(true);
    // document.body.style.overflow= 'hidden';
  };
  let blockKeys = Object.keys(MapBlock);
  const components = blockKeys.map((key) => (
    <div id={key} key={key}>
      {MapBlock[key]({}, true)}
    </div>
  ));
  return (
    <>
      <H1>Components</H1>
      <FloatBtn onClick={handleClick}>Components</FloatBtn>
      <Modal
        ref={modal}
        top={
          <div>
            <TopDefault>
              <H3>Components</H3>
              <svg
                onClick={() => modal.current?.toggle(false)}
                xmlns="http://www.w3.org/2000/svg"
                height="48"
                width="48"
              >
                <path d="m12.45 37.65-2.1-2.1L21.9 24 10.35 12.45l2.1-2.1L24 21.9l11.55-11.55 2.1 2.1L26.1 24l11.55 11.55-2.1 2.1L24 26.1Z" />
              </svg>
            </TopDefault>
          </div>
        }
        center={
          <>
            <TagList>
              {blockKeys.map((key) => (
                <a href={`#${key}`} key={key} title={key}>
                  <ComponentName>{key}</ComponentName>
                </a>
              ))}
            </TagList>
          </>
        }
        bottom={<></>}
      />
      {components}
    </>
  );
};

export const Unknown = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-gap: 8px;
  padding: 64px 32px;
  background-color: antiquewhite;
  outline: 2px dashed hsl(0deg 0% 0% / 45%);
  outline-offset: -15px;
  text-align: center;
  color: hsl(0deg 0% 0% / 65%);
  b {
    font-weight: bold;
  }
  code {
    background: hsl(0deg 0% 100% / 90%);
    padding: 4px 8px;
    border-radius: 4px;
    margin: auto;
    border-left: 5px solid;
    box-shadow: 0 3px 10px hsl(0deg 0% 0% / 13%);
  }
`;
export const Column = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-gap: 8px;
  justify-content: center;
`;

const TagList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  z-index: 2;
  grid-gap: 4px;
  overflow: auto;
  padding: 24px;

  & > * {
    background: hsl(0deg 0% 0% / 7%);
    border-radius: 3px;
    padding: 8px 24px;
    transition: 0.2s;
    user-select: none;
    cursor: pointer;
    text-decoration: none;
    color: #222;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  & > *:hover {
    background: hsl(0deg 0% 0% / 13%);
  }
  & > *:active {
    background: hsl(0deg 0% 0% / 25%);
  }
`;

const FloatBtn = styled.div`
  background: hsl(0deg 0% 0% / 85%);
  border-radius: 100px;
  padding: 8px 24px;
  transition: 0.3s ease-out;
  user-select: none;
  cursor: pointer;
  text-decoration: none;
  color: white;
  position: fixed;
  bottom: 65px;
  right: 65px;
  z-index: 900;
  &:hover {
    background: hsl(0deg 0% 0% / 75%);
    transform: scale(1.1);
  }
  &:active {
    background: hsl(0deg 0% 0% / 65%);
    transform: scale(1.15);
  }
`;

const ComponentName = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const H1 = styled.h1`
  text-align: center;
  padding-top: 90px;
  padding-bottom: 90px;
  box-shadow: 0 -35px 20px -25px inset hsla(0, 0%, 0%, 0.07);
`;

const H3 = styled.h3`
  padding: 0;
`;

const TopDefault = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 28px 20px;

  svg {
    scale: 0.7;
    fill: rgba(0, 0, 0, 0.65);
    transition: 0.3s;
    cursor: pointer;
  }
  svg:hover {
    fill: black;
  }
  @media screen and (${query.atLeast('desktop')}) {
    padding: 28px 48px;
  }
`;
